/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Newsletter_StepsInputs */

const en_directory_resources_newsletter_steps = /** @type {(inputs: Directory_Resources_Newsletter_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your email interest|Tell us what you follow|We will confirm the next issue`)
};

const zh_directory_resources_newsletter_steps = /** @type {(inputs: Directory_Resources_Newsletter_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说明订阅意向|告诉我们你关注的方向|我们会确认下一期信息`)
};

/**
* | output |
* | --- |
* | "Share your email interest\|Tell us what you follow\|We will confirm the next issue" |
*
* @param {Directory_Resources_Newsletter_StepsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_newsletter_steps = /** @type {((inputs?: Directory_Resources_Newsletter_StepsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Newsletter_StepsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_newsletter_steps(inputs)
	return zh_directory_resources_newsletter_steps(inputs)
});
export { directory_resources_newsletter_steps as "directory.resources.newsletter.steps" }